import { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const LABEL = (key, place) => (key === "pickup" ? `Pickup · ${place}` : `Stop ${key.replace("stop", "")} · ${place}`);

export function useTick(ms = 1000) {
  const [, set] = useState(0);
  useEffect(() => {
    const t = setInterval(() => set((n) => n + 1), ms);
    return () => clearInterval(t);
  }, [ms]);
}

const elapsed = (iso) => {
  const s = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};
const mins = (a, b) => Math.max(0, Math.round((new Date(b) - new Date(a)) / 60000));
const fee = (f) => (f == null ? "admin quote" : f === 0 ? "free" : `$${f.toFixed(2)}`);

export function WaitCharges({ ride }) {
  if (!ride?.wait_charges?.length) return null;
  return (
    <div className="rounded-2xl border border-white/10 p-3 text-xs" data-testid="wait-charges">
      <p className="mb-1 font-bold uppercase tracking-[0.16em] text-muted-foreground">Measured wait time</p>
      {ride.wait_charges.map((c) => (
        <p key={c.key} className="flex justify-between" data-testid={`wait-charge-${c.key}`}><span>{LABEL(c.key, c.place)} · {c.minutes} min</span><span>{fee(c.fee)}</span></p>
      ))}
      {!!ride.wait_adjustment && <p className="mt-1 text-muted-foreground" data-testid="wait-adjustment">Fare {ride.wait_adjustment > 0 ? "+" : "−"}${Math.abs(ride.wait_adjustment).toFixed(2)} vs booked wait</p>}
      {ride.wait_review && <p className="mt-1 text-amber-200">A wait went past the last tier. Scoopz Admin will set that charge.</p>}
    </div>
  );
}

export function PickupTimers({ timers = [], status, big, scheduledAt }) {
  useTick();
  if (!timers.length) return null;
  const current = timers[timers.length - 1];
  const running = !current.ended_at && ((current.key === "pickup" && ["assigned", "en_route", "arrived"].includes(status)) || (current.key !== "pickup" && status === "in_progress"));
  return (
    <div className={`rounded-2xl border p-3 ${running ? "border-primary/60 bg-primary/10" : "border-white/10"}`} data-testid="pickup-timer">
      <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.16em] text-muted-foreground">
        <Timer className="h-4 w-4 text-primary" /> {running ? "Pickup wait timer running" : "Pickup wait log"}
      </p>
      {running && <p className={`font-display font-bold text-primary ${big ? "text-4xl" : "text-2xl"}`} data-testid="pickup-timer-elapsed">{elapsed(current.started_at)}</p>}
      {running && <p className="text-[11px] text-muted-foreground">First 5 min free, then stop wait rates apply (rounded to the nearest minute).</p>}
      {timers.map((t) => (
        <p key={t.key} className="text-xs text-muted-foreground" data-testid={`pickup-timer-${t.key}`}>
          {LABEL(t.key, t.place)} · started {new Date(t.started_at).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}{t.ended_at ? ` · ${mins(t.key === "pickup" && scheduledAt && new Date(scheduledAt) > new Date(t.started_at) ? scheduledAt : t.started_at, t.ended_at)} min` : ""}
        </p>
      ))}
    </div>
  );
}
